import React from 'react';

const LayoutWithData = (props) => {
  
  console.log(props.data)
  
  return (
    <>
      LayoutWithData
    </>
  )
}

export default LayoutWithData;